import * as styles from "./css/Heading.module.css";
import * as sharedStyles from "../css/Shared.module.css";
const Heading = props => {
    return (<h1 class={`${styles.heading} ${sharedStyles.shared}${props.class ? ` ${props.class}` : ``}`}>
            {props.children}
        </h1>);
};
export { Heading };
